
export function getValue(list, fieldName) {
  const result = list && list.find(v => v.entityTitle === fieldName);
  return result && result.entityValue;
}

export function getList(list, fieldName) {
  if (!list) {
    return [];
  }
  let foundField = false;
  const result = [];
  for (let i = 0; i < list.length; i += 1) {
    const v = list[i];
    if (!foundField && v.entityTitle && v.entityTitle.startsWith(fieldName)) {
      foundField = true;
    } else if (foundField && v.entityTitle !== '&nbsp;') {
      foundField = false;
    }
    if (foundField) {
      result.push(v.entityValue);
    }
  }
  return result;
}
